/**
 * Константы для типов данных по умолчанию
 */

export interface TypeDefault {
  value: any
  type: string
}

export const TYPE_DEFAULTS: Record<string, TypeDefault> = {
  string: { value: '', type: 'String' },
  number: { value: 0, type: 'Integer' },
  integer: { value: 0, type: 'Integer' },
  float: { value: 0.0, type: 'Float' },
  double: { value: 0.0, type: 'Double' },
  boolean: { value: false, type: 'Boolean' },
  date: { value: null, type: 'Date' },
  datetime: { value: null, type: 'DateTime' },
  time: { value: null, type: 'Time' },
  array: { value: [], type: 'Array' },
  object: { value: {}, type: 'Object' },
  unidata: { value: {}, type: 'UniData' },
  unidatatable: { value: [], type: 'UniDataTable' }
}

/**
 * Получить значение по умолчанию для типа
 */
export function getDefaultForType(type: string): TypeDefault {
  const lowerType = type.toLowerCase()

  // Прямое соответствие
  if (TYPE_DEFAULTS[lowerType]) {
    return { ...TYPE_DEFAULTS[lowerType] }
  }

  // Частичное соответствие
  for (const [key, value] of Object.entries(TYPE_DEFAULTS)) {
    if (lowerType.includes(key)) {
      return { ...value }
    }
  }

  // Значение по умолчанию
  return { value: '', type: 'String' }
}

/**
 * Создать пустой объект с значениями по умолчанию для схемы
 */
export function createDefaultsFromSchema(schema: Record<string, string>): Record<string, TypeDefault> {
  const result: Record<string, TypeDefault> = {}

  for (const [key, type] of Object.entries(schema)) {
    result[key] = getDefaultForType(type)
  }

  return result
}

export default TYPE_DEFAULTS
